import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword, { ResetPassword } from "@/pages/ForgotPassword";
import OperationsManual from "@/pages/OperationsManual";
import GetTheApp from "@/pages/GetTheApp";
import CustomerDashboard from "@/pages/CustomerDashboard";
import DriverDashboard from "@/pages/DriverDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import LegalPage from "@/pages/LegalPage";
import FaqPage from "@/pages/FaqPage";
import BusinessCardPage from "@/pages/BusinessCardPage";
import PrivacyRequestPage from "@/pages/PrivacyRequestPage";
import HowItWorks from "@/pages/HowItWorks";
import AccountSettings from "@/pages/AccountSettings";
import CookieBanner from "@/components/CookieBanner";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-asap-deep font-display uppercase">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "driver") return <Navigate to="/driver" replace />;
    return <Navigate to="/customer" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/get-app" element={<GetTheApp />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/card/:slug" element={<BusinessCardPage />} />
          <Route path="/privacy-request" element={<PrivacyRequestPage />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/account" element={<AccountSettings />} />
          <Route path="/customer" element={<Protected roles={["customer", "driver"]}><CustomerDashboard /></Protected>} />
          <Route path="/driver" element={<Protected roles={["driver"]}><DriverDashboard /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
          <Route path="/manual" element={<Protected roles={["admin"]}><OperationsManual /></Protected>} />
          <Route path="/payment/success" element={<Protected roles={["customer", "driver"]}><PaymentSuccess /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
